var map = {
	"./171.svg": 19133,
	"./172.svg": 85913,
	"./173.svg": 77992,
	"./174.svg": 97799,
	"./175.svg": 10678,
	"./176.svg": 51925,
	"./Cephalometric.svg": 52673,
	"./Panoramic.svg": 53431,
	"./Profile.svg": 87076,
	"./Resive.svg": 73453,
	"./Resize.svg": 66065,
	"./chevron-down.svg": 4459,
	"./chevron-up.svg": 88567,
	"./close.svg": 55899,
	"./fi_layout.svg": 44751,
	"./frontView.svg": 15825,
	"./fullFaceNotSmiling.svg": 8869,
	"./fullFaceSmiling.svg": 77534,
	"./gridIcon.svg": 7274,
	"./hint_message_dot.svg": 28938,
	"./leftlateral.svg": 41235,
	"./lowerOcclusal.svg": 55204,
	"./rightlateral.svg": 9818,
	"./triangle.svg": 54037,
	"./upperOcclusal.svg": 5163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;